import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { extensionS1Mixin } from '../mixins/index';
import { required } from 'vuelidate/lib/validators';
import datePicker from '../../../components/forms/component.date-picker.vue';
import { MainVueOpts } from '../../../main-vue';
import { ibSpinOpts } from '../../../helper-functions/applicationCommonValues';
import { createExtensionService } from '../../../helper-functions/services';
import { onlyAlphaNumeric, monthDate, numbersWithDashSlash, noAlphabets } from '../../../helper-functions/helper-functions';

Vue.use(Vuelidate);

export default {
    mixins:[MainVueOpts, extensionS1Mixin],
    components:{
        'date-picker': datePicker
    },
    // data () {
    //     return {
    //         form: {
    //             certificateNumber: window.ibJS.extension ? window.ibJS.extension.certificateNumber ? window.ibJS.extension.certificateNumber : '' : '',
    //             birthDate: window.ibJS.extension ? window.ibJS.extension.birthDate ? window.ibJS.extension.birthDate : '' : ''
    //         },
    //         formSending: false
    //     }
    // },
    data () {
        return {
            isInternalIP: window.globalLanguage.internalIP,
        }
    },
    validations: function() {
        var validations = {
            form:{
                certificateNumber: {
                    required,
                    onlyAlphaNumeric
                },
                birthDate: {
                    required,
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets
                }
            }
        };

        return validations;
    },
    mounted() {
        if (ibJS.extensionErrors) {
            this.$emit('backenderrors', ibJS.extensionErrors);
        }
    },
    // created () {
    //     if(window.instantRenewal) {
    //         if(this.form.certificateNumber !== '' && this.form.birthDate !== ''){
    //             this.submitForm();
    //         }
    //     }
    //     if(this.form.birthDate){
    //         if(window.globalLanguage.lang == 'zh'){
    //             let date = this.form.birthDate.split('/');
    //             this.form.birthDate = date[2] + '-' + date[0] + '-' + date[1];
    //         }else if(window.globalLanguage.lang == 'es'){
    //             let date = this.form.birthDate.split('/');
    //             this.form.birthDate = date[1] + '/' + date[0] + '/' + date[2];
    //         }
    //     }
    // },
    // computed: {
    //     disableApplication:function() {

    //         if(this.formSending) {
    //             return true;
    //         }
    //         return false;
    //     }
    // },
    methods: {
        submitForm: function (e) {
            if(e) e.preventDefault();

            this.$v.$touch();

            if (this.captchaIsIncomplete()) return;

            if (!this.$v.$invalid) {
                var spinTarget=this.$refs.btnspinner;
                var spinner = new IBSpinner(ibSpinOpts).spin(spinTarget);
                this.formSending = true;
                var urlLang = '/safe-travels-extension/';
                switch(window.globalLanguage.lang) {
                    case'en' :
                        urlLang = '/safe-travels-extension/';
                        break;
                    case'es' :
                        urlLang = '/safe-travels-prorroga/';
                        break;
                    case'zh' :
                        urlLang = '/safe-travels-xubao/';
                        break;
                }
                var url = '/api'+urlLang;
                var data = JSON.stringify(this.form);
                this.resetCaptcha();
                createExtensionService.call(this, url, data, 'extension');

            } else {
                this.showMobileError = true;
            }
        },
        showResetApplicationModal() {
            this.resetForm('trawick-extension');
        }
    }
};
